import { Pipe, PipeTransform } from '@angular/core';
import { EstimationProcedure } from '@rivethealth/data/estimation';
import { EstimationTemplateProcedure } from '@rivethealth/data/estimation-template';

@Pipe({ name: 'codes', pure: true })
export class CodesPipe implements PipeTransform {
  transform(procedures: EstimationProcedure[] | EstimationTemplateProcedure[]) {
    return procedures.map(procedure => procedure.code).join(', ') || '-';
  }
}
